import React from 'react';

function TextBox() {
    return (
        <div>
            <h2 className="font-bold text-sm xl:text-base">Huomioitavaa</h2>
            <br />
            <p className="text-sm xl:text-base">Tällä laskurilla voit tarkastella pelkästään eristeiden hiilijalan- ja hiilikädenjälkeä eri U-arvoilla. Koko rakennuksen elinkaaren ympäristövaikutukset on selvitettävä erikseen.</p>
            <br />
            <h2 className="font-bold text-sm xl:text-base">Esimerkkejä U-arvoista</h2>
            <br />
            <div className="flex flex-wrap">
                <div className="md:w-1/2 xl:w-full xl:pb-4 flex justify-center">
                    <img className="" src="images/U_1.png" alt="esimerkkejä U-arvoista"></img>
                    <br />
                </div>
                <div className="md:w-1/2 xl:w-full flex justify-center">
                    <img className="" src="images/U_2.png" alt="esimerkkejä U-arvoista"></img>
                </div>
            </div>
        </div>
    )
}

export default TextBox;